import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  MatAutocompleteModule,
  MatBadgeModule,
  MatButtonModule,
  MatButtonToggleModule,
  MatCardModule,
  MatCheckboxModule,
  MatGridListModule,
  MatIconModule,
  MatInputModule,
  MatListModule,
  MatMenuModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatSelectModule,
  MatSidenavModule,
  MatSnackBarModule,
  MatTableModule,
  MatToolbarModule,
  MatTooltipModule
} from '@angular/material';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { NgDynamicBreadcrumbModule } from 'ng-dynamic-breadcrumb';
import { TextoHtmlComponent } from './components/texto-html/texto-html.component';
import { AyudaPantallaDirective } from './directives/ayuda-pantalla.directive';
import { ValidarCodigoIdespDirective } from './directives/validar-codigo-idesp.directive';
import { ValidarDocumentoDirective } from './directives/validar-documento.directive';
import { ValidarFechaActualAnteriorDirective } from './directives/validar-fecha-actual-anterior.directive';
import { CapitalizePipe } from './pipes/capitalize.pipe';
import { DialogUtilsComponent } from './util/dialog-utils/dialog-utils.component';
import { IdToLabelPipe } from './pipes/idToLabel.pipe';

@NgModule({
  providers: [],
  declarations: [
    CapitalizePipe,
    IdToLabelPipe,
    DialogUtilsComponent,
    AyudaPantallaDirective,
    ValidarDocumentoDirective,
    ValidarCodigoIdespDirective,
    ValidarFechaActualAnteriorDirective,
    TextoHtmlComponent,
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    MatTooltipModule,
    FlexLayoutModule,
    TranslateModule,
  ],
  exports: [
    TranslateModule,
    FlexLayoutModule,
    CapitalizePipe,
    IdToLabelPipe,
    FormsModule,
    ReactiveFormsModule,
    MatSnackBarModule,
    MatButtonModule,
    MatCardModule,
    MatIconModule,
    MatListModule,
    MatMenuModule,
    MatSidenavModule,
    MatSelectModule,
    MatToolbarModule,
    MatInputModule,
    MatInputModule,
    MatGridListModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatButtonToggleModule,
    MatBadgeModule,
    MatTooltipModule,
    MatAutocompleteModule,
    MatCheckboxModule,
    NgDynamicBreadcrumbModule,
    ValidarDocumentoDirective,
    ValidarCodigoIdespDirective,
    AyudaPantallaDirective,
    ValidarFechaActualAnteriorDirective,
    TextoHtmlComponent,
    MatTableModule,
  ],
  entryComponents: [DialogUtilsComponent],
})
export class SharedModule { }
